import { useQuery } from "@tanstack/react-query";
import { getSettlementReportsSettlementPeriods } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const SETTLEMENT_PERIODS_QUERY_KEY = "SETTLEMENT_PERIODS";

export const settlementPeriodsQueryKeys = {
  all: [SETTLEMENT_PERIODS_QUERY_KEY],
};

export const useGetSettlementPeriodsQuery = () =>
  useQuery({
    queryKey: settlementPeriodsQueryKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getSettlementReportsSettlementPeriods(),
    ),
  });
